import CardHeader from "@pathwright/ui/src/components/card/CardHeader"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import { useCurrencyFormatter } from "../../../currency/CurrencyFormatterProvider"
import { LICENSING_MODE_SCHOOL_LICENSING } from "../../../store/resource/offering/license/constants"
import {
    getDescriptorLabelForOffering,
    getPriceForOffering
} from "../../../store/resource/utils/offering-utils"
import { getResourceTypeLabel } from "../../utils"

const LicenseResourceHeader = (props) => {
  const { currencyFormatter } = useCurrencyFormatter()

  if (!props.license_offering) {
    return null
  }

  const { card, license_offering, licenseeSchool, t, tc } = props

  const price = getPriceForOffering(license_offering)
  const displayPrice = currencyFormatter.customFormat(price)
  const resourceType = getResourceTypeLabel(
    license_offering.resource.resource_type,
    tc
  )

  const meta =
    licenseeSchool &&
    license_offering.licensing_mode === LICENSING_MODE_SCHOOL_LICENSING
      ? t("resource.licensing_form.get_for_school", {
          resourceType,
          schoolName: licenseeSchool.name
        })
      : price === "Free"
      ? t("resource.licensing_form.get_for_free", {
          resourceType
        })
      : price
      ? `${t("resource.licensing_form.get_for_price", {
          resourceType,
          price: displayPrice
        })}${getDescriptorLabelForOffering(license_offering, t)}`
      : t("resource.licensing_form.get", {
          resourceType
        })

  return (
    <CardHeader
      card={card}
      resource={license_offering.resource}
      title={license_offering.resource.name}
      meta={meta}
    />
  )
}

LicenseResourceHeader.displayName = "LicenseResourceHeader"

export default withTranslate(LicenseResourceHeader)
